"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
function SvgPrintOutline(props) {
    return (React.createElement("svg", __assign({ xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 32 32" }, props),
        React.createElement("path", { d: "M30 11.43l-.49-.29A21.94 21.94 0 0025 9.3V3H7v6.3a22 22 0 00-4.5 1.84l-.5.29V23h5v6h18v-6h5zM9 5h14v3.78a31.8 31.8 0 00-14 0zm14 22H9V17h14zm5-6h-3v-6H7v6H4v-8.4A28 28 0 0116 10a28 28 0 0112 2.6z" })));
}
exports.default = SvgPrintOutline;
//# sourceMappingURL=PrintOutline.js.map